var h = Object.defineProperty;
var o = (n, s, e) => s in n ? h(n, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[s] = e;
var c = (n, s, e) => (o(n, typeof s != "symbol" ? s + "" : s, e), e);
class w {
  constructor(s = {}) {
    c(this, "defaultOptions", {
      baseUrl: "https://pawket.app",
      network: "ccd5bb71183532bff220ba46c268991a3ff07eb358e8255a65c30a2dce0e5fbb",
      width: 390,
      height: 844,
      name: "Pawket",
      timeout: 2e3
    });
    this.configs = g({}, this.defaultOptions, s);
  }
  _openPawket(s = {}) {
    let e = g({}, this.configs, s);
    this.pawket = window.open(
      e.baseUrl + "#/connect",
      e.name + Date.now(),
      `width=${e.width},height=${e.height}`
    );
  }
  _sendMessage(s, e, t = {}) {
    let a = g({}, this.configs, t);
    setTimeout(
      () => {
        var i;
        return (i = this.pawket) == null ? void 0 : i.postMessage(
          JSON.stringify({
            cmd: s,
            data: e,
            network: a.network
          }),
          a.baseUrl
        );
      },
      a.timeout
    );
  }
  _getMessage(s) {
    const e = this.pawket;
    return new Promise((t, a) => {
      let i = !1;
      window.onmessage = (d) => {
        d.origin !== this.configs.baseUrl || d.data.cmd != s || (i = !0, d.data.status == "success" ? t(d.data.msg) : (d.data.status || (d.data.status = "unknown"), a(d.data)));
      };
      const r = setInterval(function() {
        if (i) {
          clearInterval(r);
          return;
        }
        e.closed && (clearInterval(r), a({ status: "closed" }));
      }, 1e3);
    });
  }
  takeOffer(s, e = {}) {
    const t = "take-offer";
    return this._openPawket(e), this._sendMessage(t, s, e), this._getMessage(t);
  }
  send(s, e = {}) {
    const t = "send";
    return this._openPawket(e), this._sendMessage(t, s, e), this._getMessage(t);
  }
  getAddress(s = {}) {
    const e = "get-address";
    return this._openPawket(s), this._sendMessage(e, {}, s), this._getMessage(e);
  }
  getDid(s = {}) {
    const e = "get-did";
    return this._openPawket(s), this._sendMessage(e, {}, s), this._getMessage(e);
  }
  signWithDid(s, e, t = {}) {
    const a = "sign-with-did";
    this._openPawket(t);
    const i = JSON.stringify({ did: s, message: e });
    return this._sendMessage(a, i, t), this._getMessage(a);
  }
  signWithAddress(s, e, t = {}) {
    const a = "sign-with-address";
    this._openPawket(t);
    const i = JSON.stringify({ address: s, message: e });
    return this._sendMessage(a, i, t), this._getMessage(a);
  }
  addCat(s, e = "", t = {}) {
    const a = "add-cat";
    this._openPawket(t);
    const i = JSON.stringify({ id: s, name: e });
    return this._sendMessage(a, i, t), this._getMessage(a);
  }
}
function g(n, ...s) {
  const e = s.map((t) => Object.entries(t).filter(([, a]) => a !== void 0).reduce((a, [i, r]) => (a[i] = r, a), {}));
  return Object.assign(n, ...e);
}
export {
  w as Pawket
};
